module.exports = __webpack_public_path__ + "ath_game_web/img/Hingstonsmile.6c7d2605.png";